import { OfferTransaction } from '@/api';
import useAuth from '@/contexts/AuthContext';
import useItemContext from '@/hooks/useItemContext';
import i18next from 'i18next';
import React from 'react';
import Checkmark from 'public/assets/icons/checkmark.svg';
import ExMark from 'public/assets/icons/exclamation-mark.svg';
import useOffers from '@/hooks/useOffers';
import If from '@/components/util/IF';

const ProductEcomNotifications = () => {
    const { item } = useItemContext();
    const { user } = useAuth();
    const { currentOffer } = useOffers(item, true);

    const congratsPurchased = item?.current_offer_transaction && item?.current_offer_transaction.status === OfferTransaction.StatusEnum.Pending && item?.owner_id !== user?.id;
    const inTransaction = item?.current_offer_transaction && item?.current_offer_transaction.status === OfferTransaction.StatusEnum.Paid && item?.owner_id === user?.id;
    const awaitingShippingSeller = item?.current_offer_transaction && item?.current_offer_transaction.status === OfferTransaction.StatusEnum.Paid && item?.owner_id !== user?.id;
    const awaitingReAuth = item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.OfficeReceived;
    const reAuthenticated = item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.Reauthenticated;
    const reAuthFailed = item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.ReauthenticatedFailed;
    const shipped = item?.owner_id !== user?.id && (item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.ShippedToBuyer);
    const completed = item?.owner_id !== user?.id && (item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.Done);
    const offerSoldGratz = currentOffer?.is_accepted && item?.owner_id === user?.id && item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.Pending;
    const offerTransCompleted = item?.owner_id === user?.id && (item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.ShippedToBuyer || item?.current_offer_transaction?.status === OfferTransaction.StatusEnum.Done);

    return (
        <>
            <If condition={congratsPurchased}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green4 text-green5 rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span> {i18next.t('common:offers.congrats-purchased')}
                </div>
            </If>
            <If condition={inTransaction}>
                <div className="flex items-center text-[14px] leading-[14px] py-[18px] px-4 justify-center  mb-4 bg-grey16 text-black rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><ExMark className="text-black" /></span> {i18next.t('common:offers.in-transaction-print-label')}
                </div>
            </If>
            <If condition={awaitingShippingSeller}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green4 text-green5 rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span> {i18next.t('common:offers.awaiting-shipping-seller')}
                </div>
            </If>
            <If condition={awaitingReAuth}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-grey16 text-black rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><ExMark className="text-black" /></span>      {i18next.t('common:offers.awaiting-reauthentication')}
                </div>
            </If>
            <If condition={reAuthenticated}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green4 text-green5 rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span>   {i18next.t('common:offers.reauthenticated')}
                </div>
            </If>
            <If condition={reAuthFailed}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-grey16 text-red4 rounded-[8px]">
                    {i18next.t('common:offers.reauthenticated-failed')}
                </div>
            </If>
            <If condition={shipped}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green4 text-green5 rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span>    {i18next.t('common:offers.shipped')}
                </div>
            </If>
            <If condition={completed}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-grey16 text-black rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span>  {i18next.t('common:offers.transaction-completed')}
                </div>
            </If>
            <If condition={offerSoldGratz}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green4 text-green5 rounded-[8px]">
                    <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span> {i18next.t('common:offers.congrats-sold')}
                </div>
            </If>
            <If condition={offerTransCompleted}>
                <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-grey16 text-black rounded-[8px]">
                    {i18next.t('common:offers.transaction-completed')}
                </div>
            </If>
        </>
    );
};

export default ProductEcomNotifications;
